var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{ref:"inputElement",staticClass:"uk-input",attrs:{"type":"text"},on:{"keypress":function($event){return _vm.$emit('keypress', $event)},"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }